import Const from 'constants';

const defaultState = {
    data: {},
    isExcluded(playerId, mode = Const.FLEX_MODE) {
        return this.data.hasOwnProperty(mode) && this.data[mode].hasOwnProperty(playerId);
    },
    isExcludedAnywhere(playerId) {
        const data = Object.values(this.data);
        for (let mode of data) {
            if (mode.hasOwnProperty(playerId)) {
                return true;
            }
        }
        return false;
    },
    all() {
        return {...this.data};
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.EXCLUSION_SET_PLAYERS) {
        Object.keys(action.items).map((mode) => {
            state.data[mode] ??= {};
            Object.keys(action.items[mode]).map((playerId) => {
                if (Boolean(action.items[mode][playerId])) {
                    state.data[mode][playerId] = true;
                } else if (state.data[mode].hasOwnProperty(playerId)) {
                    delete state.data[mode][playerId];
                }
            });
        });
    } else if (action.type === Const.LOCKING_SET_PLAYERS) {
        Object.keys(action.items).map((mode) => {
            if (!state.data.hasOwnProperty(mode)) {
                return;
            }
            Object.keys(action.items[mode]).map((playerId) => {
                if (Boolean(action.items[mode][playerId]) && state.data[mode].hasOwnProperty(playerId)) {
                    delete state.data[mode][playerId];
                }
            });
        });
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultState, data: {}};
    }

    return state;
}
